const LAMBDA_PAYLOAD_LIMIT_BYTES = 3 * 1024 * 1024 // 3 MB
const MAX_BATCH_SIZE_BYTES = LAMBDA_PAYLOAD_LIMIT_BYTES

export const createFileBatches = (files) => {
  const batches = []
  let currentBatch = []
  let currentBatchSize = 0

  const filesToBatch = files.filter((file) => file.type === 'blob')

  for (const file of filesToBatch) {
    const fileSize = file.size || 0

    if (fileSize > MAX_BATCH_SIZE_BYTES) {
      if (currentBatch.length > 0) {
        batches.push(currentBatch)
        currentBatch = []
        currentBatchSize = 0
      }
      batches.push([file])
      continue
    }

    if (currentBatch.length > 0 && (currentBatchSize + fileSize) > MAX_BATCH_SIZE_BYTES) {
      batches.push(currentBatch)
      currentBatch = []
      currentBatchSize = 0
    }

    currentBatch.push(file)
    currentBatchSize += fileSize
  }

  if (currentBatch.length > 0) {
    batches.push(currentBatch)
  }

  return batches
}
